module.exports = __webpack_public_path__ + "static/q19_x-3b0a79f7c669c286b241356fc2970539.png";